import React from 'react';
import { dashboardFiltersReducer } from './reducer';
import { Company, Multimedia } from '../../../models';
import { useGoalsDashboard } from '../../../hooks';
import Points from '../../point/pointsInDashboard/Points';
import DoughnutChart from '../Charts/DouhnutChart/DoughnutChart';
import LeaderBoard from '../LeaderBoard/LeaderBoard';
import Filters from './Filters';

interface GoalsDashboardProps {
  company: Company;
}

function GoalsDashboard({ company }: GoalsDashboardProps) {
  const [state, dispatch] = React.useReducer(dashboardFiltersReducer, {
    startDate: '',
    endDate: '',
    goal: '',
    period: '',
    fieldType: 'structure',
  });

  const goalDashboard = useGoalsDashboard(company, state);

  const leaderBoardData = React.useMemo(() => {
    const _data = goalDashboard?.leaderBoard?.data?.map((item) => ({
      amount: item.totalRewarded,
      name: `${item?.user?.firstName} ${item?.user?.lastName}`,
      photoSrc: (item?.user.photo as Multimedia)?.src ?? '',
    }));

    return _data?.slice(0, 7);
  }, [goalDashboard?.leaderBoard?.data, goalDashboard?.leaderBoard.loading]);

  return (
    <div className="w-full flex flex-col space-y-10">
      <Points
        pointsBalance={goalDashboard.totalPoints.pointsBalance || 0}
        pointsAssigned={goalDashboard.totalPoints.pointsAssigned || 0}
        pointsRedeemed={goalDashboard.totalPoints.pointsRedeemed || 0}
      />
      <Filters
        company={company}
        state={state}
        dispatch={dispatch}
        loading={goalDashboard?.loading}
        refreshDashboard={goalDashboard?.refreshDashboard}
      />
      <div className="flex w-full h-full space-y-6 lg:space-y-0 lg:space-x-4 flex-col lg:flex-row">
        <div className="w-full lg:w-1/3 space-y-4 flex flex-col ">
          <LeaderBoard
            data={leaderBoardData ?? []}
            loading={goalDashboard?.leaderBoard?.loading}
            title="Ranking de puntos ganados"
            amountType="number"
          />
        </div>
        <div className="w-full lg:w-2/3 flex flex-col space-y-4 relative">
          <DoughnutChart
            data={goalDashboard?.doughnut?.data ?? []}
            labels={goalDashboard?.doughnut?.labels ?? []}
            loading={goalDashboard?.doughnut?.loading}
            title={`Porcentaje de cumplimiento de meta - ${
              company?.companyDetails?.goals?.find(
                (goal) => goal?._id === state?.goal
              )?.metric ?? ''
            }`}
          />
          <h1 className="absolute top-12 right-6 ">
            {goalDashboard?.doughnut.kpiInfo.totalTarget} de{'  '}
            {goalDashboard?.doughnut.kpiInfo.totalCollected}
          </h1>
        </div>
      </div>
    </div>
  );
}

export default GoalsDashboard;
